import { render, staticRenderFns } from "./VenueModal.vue?vue&type=template&id=542c8c49&scoped=true"
import script from "./VenueModal.vue?vue&type=script&lang=js"
export * from "./VenueModal.vue?vue&type=script&lang=js"
import style0 from "./VenueModal.vue?vue&type=style&index=0&id=542c8c49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c8c49",
  null
  
)

export default component.exports